module.exports = __webpack_public_path__ + "static/img/Check-3D.db789d96.svg";